import { render, staticRenderFns } from "./ColorListingg.vue?vue&type=template&id=99fd56e4&scoped=true"
import script from "./ColorListingg.vue?vue&type=script&lang=js"
export * from "./ColorListingg.vue?vue&type=script&lang=js"
import style0 from "./ColorListingg.vue?vue&type=style&index=0&id=99fd56e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fd56e4",
  null
  
)

export default component.exports